import JsPDF from 'jspdf';
import moment from 'moment';
import _ from 'lodash';
import { DialogProgrammatic } from '../Dialog';
import store from '../../store';
import Company from '../../models/Companies';

const defaultQRLabel = {
  shipping: [
    { label: 'Project', value: 'projectName' },
    { label: 'Proj ID', value: 'projectId' },
    { label: 'Order', value: 'orderName' },
    { label: 'Desc', value: 'orderId' },
    { label: 'Hide Field', value: 'hide' },
  ],
  item: [
    { label: 'Project', value: 'projectName' },
    { label: 'Proj ID', value: 'projectId' },
    { label: 'Item', value: 'itemName' },
    { label: 'Item ID', value: 'itemId' },
    // { label: 'Cost Code', value: 'itemCostCode' },
  ],
  inventoryItem: [
    { label: 'Item', value: 'itemName' },
    { label: 'Item ID', value: 'customId' },
    { label: 'Catalog Id', value: 'catId' },
    { label: 'Cost Code', value: 'itemCostCode' },
  ],
  partial: [
    { label: 'Project', value: 'projectName' },
    { label: 'Proj ID', value: 'projectId' },
    { label: 'Shipment', value: 'name' },
    { label: 'Track ID', value: 'trackingId' },
  ],
  serial: [
    { label: 'Project', value: 'projectName' },
    { label: 'Proj ID', value: 'projectId' },
    { label: 'Order', value: 'orderName' },
    { label: 'Item', value: 'itemName' },
    { label: 'Item ID', value: 'itemId' },
  ],
  material: [
    { label: 'Project', value: 'projectName' },
    { label: 'Proj ID', value: 'projectId' },
    { label: 'Order', value: 'orderName' },
    { label: 'Submittal', value: 'submittal' },
  ],
  materialItems: [
    { label: 'Project', value: 'projectName' },
    { label: 'Proj ID', value: 'projectId' },
    { label: 'Item', value: 'itemName' },
    { label: 'Item ID', value: 'itemId' },
    { label: 'Submittal', value: 'submittal' },
  ],
};

async function printQRPdf(qrCodes, User) {
  let customTemplate = await Company.qrLabel(User.company);
  if (_.isEmpty(customTemplate.shipping)) {
    customTemplate = defaultQRLabel;
  }
  const d = 5; // diff between two lines
  const br = 1; // extra line

  let pdfPageCount = 0;
  let pdf = new JsPDF('l', 'mm', [50.8, 101.6]);
  const pdfFontFamily = 'helvetica';
  pdf.setFont(pdfFontFamily);
  if (!_.isEmpty(qrCodes[0])) {
    _.forEach(qrCodes, (qrimg, k) => {
      if (_.isEmpty(qrimg.companyName) && User?.company?.name) {
        qrimg.companyName = User.company.name;
      }
      if (pdfPageCount > 0) { pdf.addPage(); }
      let x = 4;
      let templateName = 'item';
      if (qrimg.type === 'basecard') {
        templateName = 'shipping';
      } else if (qrimg.type === 'baseMaterial') {
        templateName = 'material';
      } else if (qrimg.type === 'materialItem') {
        templateName = 'materialItems';
      } else if (_.isEqual(qrimg.type, 'shipping') && _.isEqual(qrimg.psItem, 'delivery')) {
        templateName = 'shippingDelivery';
      } else if (_.isEqual(qrimg.type, 'shipping')) {
        templateName = 'partial';
      } else if (_.isEqual(qrimg.type, 'serial') || _.isEqual(qrimg.type, 'psItem')) {
        templateName = 'serial';
      } else if (_.isEqual(qrimg.type, 'inventoryItem')) {
        templateName = 'inventoryItem';
      }
       let headerLabel = '';
      switch (qrimg.type) {
        // ------------ for production
        case 'basecard':
          headerLabel = 'Production Order';
          break;
        case 'item':
          headerLabel = 'Production Item';
          break;

        // -------------- for shipping
        case 'shipping':
        if (qrimg.psItem === 'delivery') {
          headerLabel = 'Shipping Delivery';
        } else {
          headerLabel = 'Shipping Order';
        }
        break;
        case 'psItem':
          headerLabel = 'Delivery Item';
          break;

        // ------------- for material
        case 'baseMaterial':
          headerLabel = 'Material Order';
          break;
        case 'materialItem':
          headerLabel = 'Material Item';
          break;

        //---------------FOR INVENTORY
        case 'inventoryItem':
          headerLabel = 'Inventory Item';
          break;

        default:
          headerLabel = '';
      }
      let chosenTemplate = {};
      if (!_.compact(customTemplate[templateName])?.length) {
        chosenTemplate = defaultQRLabel[templateName];
      } else {
        chosenTemplate = customTemplate[templateName];
      }
      
      // let count = 0;
      if (!_.isEmpty(chosenTemplate)) {
        // _.each(chosenTemplate, (val) => {
        //   if (val.value !== 'hide') {
        //     count += 1;
        //   }
        // });
        // if (count <= 2) {
        //   pdf.setFontSize(10);
        // } else if (count === 3) {
        //   pdf.setFontSize(8);
        // } else {
          pdf.setFontSize(7);
        // }
        _.each(chosenTemplate, (val) => {
          if (!_.isEmpty(qrimg) && !_.isEmpty(val.value) && val.value !== 'hide') {
            x = x + d + br;
            pdf.setFont(pdfFontFamily, 'bold');
            let value = val.label;
            if (value.length > 55) { value = `${value.substring(0, 75)}...`; }
            let itemTitle = pdf.splitTextToSize(`${value}:`, 40);
            if (val.value === 'orderId' && value.toLowerCase() === 'desc' && itemTitle[0].includes(':')) {
              itemTitle[0] = itemTitle[0].replace(':', '.:');
            }
            pdf.text(42, x, itemTitle);
            pdf.setFont(pdfFontFamily, 'normal');
            value = '';
            if (!_.isEmpty(qrimg) && val.value === 'itemId' && qrimg.type === 'inventoryItem' && qrimg.customId) {
              value = qrimg.customId.toString();
            }
            if (!_.isEmpty(qrimg) && !_.isEmpty(qrimg[val.value])) {
              value = qrimg[val.value].toString();
            }
            if (value.length > 55) {
              value = `${value.substring(0, 55)}...`;
            }
            itemTitle = pdf.splitTextToSize(value, 41);
            pdf.text(56, x, '');
            pdf.text(57, x, itemTitle);
          }
        });
      }
      if (!_.isEmpty(qrimg.imageData)) {
        pdf.addImage(qrimg.imageData, 'png', 6, 12, 27, 28);
      }
      if (!_.isEmpty(qrimg.companyLogo)) {
        pdf.addImage(qrimg.companyLogo, 'png', 3, 4, 35, 8);
      } else if (!_.isEmpty(qrimg.companyName)) {
        pdf.setFont(pdfFontFamily, 'bold');
        pdf.setFontSize(9);
        const wrappedCompanyName = pdf.splitTextToSize(qrimg.companyName, 35); 
        pdf.text(20, 7, wrappedCompanyName, { align: 'center' });
        pdf.setFontSize(7);
      } 

      if (headerLabel) {
        pdf.setFont(pdfFontFamily, 'bold');
        pdf.setFontSize(9);
        const textX = 20;
        const textY = 48;
        pdf.text(textX, textY, headerLabel, { align: 'center' });
        pdf.setFontSize(7);
      }
      if (_.isEqual(qrimg.type, 'serial')) {
        pdf.text(44, 38, 'Serial: ');
        pdf.text(55, 38, qrimg.itemSerial);
      }
      if (!_.isEmpty(qrimg.appLogo)) {
        const qrX = 6;
        const qrW = 27;
        const qrCenterX = qrX + qrW / 2;
        const logoW = 20;
        const logoH = 4;
        const logoX = qrCenterX - logoW / 2; 
        const logoY = 39;
        pdf.addImage(qrimg.appLogo, 'png', logoX, logoY, logoW, logoH);
      }


    switch (qrimg.type) {
      // ---------- PRODUCTION ----------
      case 'basecard':
        if (!_.isUndefined(qrimg.itemCount)) {
          pdf.text(44, 45, 'Total #Items:');
          pdf.text(72, 45, qrimg.itemCount.toString());
        }
        break;

      case 'item': // Prod Item
        const prodItemQty = qrimg.itemCount;
        if (!_.isUndefined(prodItemQty)) {
          pdf.text(44, 45, 'Item QTY:');
          pdf.text(72, 45, prodItemQty.toString());
        }
        const measure = qrimg.itemMeasure;
        const units = qrimg.itemMeasureUnits;
        if (measure || units) {
          pdf.text(44, 49, 'Measure/Unit:');
          pdf.text(72, 49, `${measure} ${units}`.trim());
        }
        break;


      // ---------- MATERIAL ----------
      case 'baseMaterial':
        if (!_.isUndefined(qrimg.itemCount)) {
          pdf.text(44, 45, 'Total #Materials:');
          pdf.text(72, 45, qrimg.itemCount.toString());
        }
        break;

      case 'materialItem':
        const matItemQty = qrimg.itemCount;
        if (!_.isUndefined(matItemQty)) {
          pdf.text(44, 45, 'Material QTY:');
          pdf.text(72, 45, matItemQty.toString());
        }
        const matMeasure = qrimg.itemMeasure;
        const matUnits = qrimg.itemMeasureUnits;
        if (matMeasure || matUnits) {
          pdf.text(44, 49, 'Measure/Unit:');
          pdf.text(72, 49, `${matMeasure} ${matUnits}`.trim());
        }
        break;

      // ---------- SHIPPING ----------
      case 'shipping':
        if (!_.isUndefined(qrimg.itemCount)) {
          pdf.text(44, 45, 'Total #Deliveries:');
          pdf.text(72, 45, qrimg.itemCount.toString());
        }
        break;

      case 'psItem':
        if (!_.isUndefined(qrimg.itemCount)) {
          pdf.text(44, 45, 'Total #Items:');
          pdf.text(72, 45, qrimg.itemCount.toString());
        }
        if (!_.isUndefined(qrimg.itemQuantity)) {
          pdf.text(44, 49, 'Item QTY:');
          pdf.text(72, 49, qrimg.itemQuantity.toString());
        }
        break;

      // ---------- DELIVERY ITEM ----------
      case 'serial':
        if (!_.isUndefined(qrimg.itemQuantity)) {
          pdf.text(44, 45, 'Item QTY:');
          pdf.text(72, 45, qrimg.itemQuantity.toString());
        }
        break;

      // ---------- INVENTORY ----------
      case 'inventoryItem':
        if (!_.isUndefined(qrimg.itemQuantity)) {
          pdf.text(44, 45, 'Item QTY:');
          pdf.text(72, 45, qrimg.itemQuantity.toString());
        }
        break;

      default:
        break;
    }
      pdfPageCount += 1;
      if (k > 1 && (k % 1000) === 0) {
        pdf.save(`ManufactOn-${moment().format()}.pdf`);
        pdf = new JsPDF('l', 'mm', [50.8, 101.6]);
        pdf.setFontSize(10);
        pdfPageCount = 0;
      }
    });
  }
  pdf.save(`ManufactOn-${moment().format()}.pdf`);
}

export default {
  async printQrLabel(qrCodes, User) {
    const { companyLogo } = qrCodes[0];
    if (store.state.activeScreen === 'shipping-order-view') qrCodes = _.sortBy(qrCodes, (code) => code.viewIndex);
    if (_.isEmpty(companyLogo)) {
      const confirmParam = {
        title: _.upperCase('company logo missing'),
        message: 'You haven\'t customized QR label in Manufacton Settings yet! Do you still want to proceed?',
        okButton: 'Print QR Now',
        type: 'black-bis',
        cancelButton: 'Add Logo',
        onConfirm: async () => {
          await printQRPdf(qrCodes, User);
        },
        onClose: () => {
          window.location.href = '#/settings/projects';
        },
      };
      DialogProgrammatic.confirm(confirmParam);
    } else {
      await printQRPdf(qrCodes, User);
    }
  },
};
